export const convertBlockCode = (code: string) => {
    const trimmedCode = code.trim().toUpperCase();
    const length = code.length;
    const blocks = [];
    
    for (let i = 0; i < length; i += 4) {
        blocks.push(trimmedCode.substring(i, i + 4));
    }

    return blocks.join(" ");
};

// Character budget of the personal message printed on the voucher PDF and sent by mail.
// Mirrors the `max:2000` rule shared by VoucherRequest and the SpaceManager/journal voucher
// endpoints — keep both in step, the textarea is the only place a user sees the limit.
export const VOUCHER_MESSAGE_MAX_LENGTH = 2000;
